import { TopicVo } from "./TopicVo";

export class SubCatVo {
    public id: number;
    public subcatName: string;
    public topics:TopicVo[]=[];
    public slug:string='';
    constructor(id: number, subcatName: string) {
        this.id = id;
        this.subcatName = subcatName;
    }
}